import { Category } from '../types';

// Predefined color palette with visually distinct colors
const COLOR_PALETTE = [
  '#3B82F6', // Blue
  '#10B981', // Green  
  '#F59E0B', // Yellow
  '#EF4444', // Red
  '#8B5CF6', // Purple
  '#EC4899', // Pink
  '#06B6D4', // Cyan
  '#F97316', // Orange
  '#6366F1', // Indigo
  '#14B8A6', // Teal
];

export function getDistinctColor(existingCategories: Category[]): string {
  // If no categories exist, return the first color
  if (existingCategories.length === 0) {
    return COLOR_PALETTE[0];
  }

  // Get currently used colors
  const usedColors = new Set(existingCategories.map(cat => cat.color));

  // Find the first unused color
  const availableColor = COLOR_PALETTE.find(color => !usedColors.has(color));
  if (availableColor) {
    return availableColor;
  }

  // If all colors are used, find the least used color
  const colorCounts = new Map<string, number>();
  COLOR_PALETTE.forEach(color => colorCounts.set(color, 0));
  
  existingCategories.forEach(category => {
    const count = colorCounts.get(category.color) || 0;
    colorCounts.set(category.color, count + 1);
  });

  // Find color with minimum usage
  let minUsageColor = COLOR_PALETTE[0];
  let minUsage = Infinity;

  colorCounts.forEach((count, color) => {
    if (count < minUsage) {
      minUsage = count;
      minUsageColor = color;
    }
  });

  return minUsageColor;
}